import { addToCollection, getCollectionRef } from "./basicOperations";

export const createDoc = async (collection: string, data: any) => {
  const appCollection = await getCollectionRef(collection);

  const addResponse = await addToCollection(appCollection, data);
  return addResponse;
};
